import React, { Component } from 'react';
import PropTypes from 'prop-types';

import css from './Address.module.scss';
import WidgetPagePropTypes from '../../WidgetPage/types';
import Address from './index';
import layoutCSS from '../../../components/Layout/Layout.module.scss';
import Message from '../../../components/UI/Message';

class LegalAddress extends Component {
  constructor(props) {
    super(props);

    this.state = {
      legalAddress: {
        address: '',
        address2: '',
        city: '',
        state: '',
        zip: ''
      }
    };
  }

  componentDidMount() {
    this.props.clearError();
    window.scrollTo(0, 0);
    this.props.segment.page('Registration', 'PO Box');
  }

  updateAddress = address => {
    this.setState({ legalAddress: address });
  };

  answer = async () => {
    const questions = Array.from(this.props.questions);
    const answers = Array.from(this.props.answers);

    const legalAddressPosition =
      this.props.questions.indexOf('set_legal_address');
    const shippingAddress = this.props.answers[legalAddressPosition];

    answers[legalAddressPosition] = this.state.legalAddress;

    questions.push('set_shipping_address');
    answers.push(shippingAddress);

    this.props.onSubmit(questions, answers);
  };

  render() {
    const firstNameLocation = this.props.questions.indexOf(
      'set_legal_first_name'
    );

    const firstName =
      firstNameLocation !== -1
        ? this.props.answers[firstNameLocation]
        : this.props.app.answers.setLegalFirstName;

    const lastNameLocation = this.props.questions.indexOf(
      'set_legal_last_name'
    );
    const lastName =
      lastNameLocation !== -1
        ? this.props.answers[lastNameLocation]
        : this.props.app.answers.setLegalLastName;

    const shippingAddressLocation =
      this.props.questions.indexOf('set_legal_address');
    const shippingAddress =
      shippingAddressLocation !== -1
        ? this.props.answers[shippingAddressLocation]
        : this.props.app.answers.setLegalAddress;

    return (
      <div data-e2e="legal-address" data-testid="legal-address">
        <div className={layoutCSS.layoutWrapper}>
          <div className={css.shippingAddress}>
            <h3>Great, we’ll mail your cards here:</h3>
            <div data-e2e="shipping-address" data-testid="shipping-address">
              {shippingAddress && (
                <>
                  <p>
                    {firstName && firstName} {` `} {lastName && lastName}
                  </p>
                  <p>{shippingAddress.address}</p>
                  <p>{shippingAddress.address2 && shippingAddress.address2}</p>
                  <p>
                    {shippingAddress.city}, {shippingAddress.state}{' '}
                    {shippingAddress.zip}
                  </p>
                </>
              )}
              <a onClick={this.props.resetToConfirmId} data-e2e="edit-address">
                Edit
              </a>
            </div>
          </div>
          <h3 data-e2e="po-address-header">
            But, to verify your identity, we still need the actual address where
            you live (it cannot be a PO Box)
          </h3>
          <h2>
            To help the government fight the funding of terrorism and money
            laundering activities, federal law requires Greenlight to obtain,
            verify, and record information that identifies each person who opens
            an account. When you open an account, Greenlight asks for your name,
            address, date of birth, and other information that allows us to
            identify you. We may also ask to see your driver's license and other
            identifying information.
          </h2>
          <Message
            error={this.props.app.error || this.state.error}
            text={this.props.app.message || this.state.message}
          />
          <div>
            <Address
              ref={'legalAddress'}
              legalAddress
              changeAnswerValue={this.updateAddress}
              widget={'legalAddress'}
              index={0}
              answerLegalAddress={this.answer}
              {...this.props}
            />
          </div>
        </div>
      </div>
    );
  }
}

LegalAddress.propTypes = {
  app: WidgetPagePropTypes.app,
  answer: WidgetPagePropTypes.answer
};

export default LegalAddress;
